<template>
  <v-btn icon class="custom-button" :style="`width: ${size * 1.5}px; height: ${size * 1.5}px;`">
    <v-icon v-text="icon" :size="size" color="white" />
  </v-btn>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      required: false,
      default: 48,
    },
  },
};
</script>

<style scoped>
.custom-button {
  background: transparent linear-gradient(180deg, #0000ca 0%, #00cdf9 100%) 0% 0% no-repeat
    padding-box;
  box-shadow: 0px 3px 6px #00000029;
}
</style>
